import { actionCreator } from '@/utils/redux';

import { InitialData, NAMESPACE } from './types';

const creator = actionCreator(NAMESPACE);

export interface StoreAuthActionPayload {
  initialData?: InitialData;
  success: boolean;
  isNewUser: boolean;
  token?: string;
}

export interface NotifyInitializationFinishedActionPayload {
  success: boolean;
  isNewUser: boolean;
}

// sagas
export const saveForbidden = creator.asyncActionWithPayload<boolean, void>('SAVE_FORBIDDEN');

// reducers
export const storeAuth = creator.syncActionWithPayload<StoreAuthActionPayload>('STORE_AUTH');
export const storeExpired = creator.syncActionWithPayload<boolean>('STORE_EXPIRED');
export const storeForbidden = creator.syncActionWithPayload<boolean>('STORE_FORBIDDEN');
export const storeLogout = creator.syncAction('STORE_LOGOUT');

// notifications
export const notifyAuthorizationFinished = creator.syncActionWithPayload<NotifyInitializationFinishedActionPayload>(
  'AUTH_FINISHED',
);

export default {
  saveForbidden,
  storeAuth,
  storeExpired,
  storeForbidden,
  storeLogout,
  notifyAuthorizationFinished,
};
